// Product data for the one-page site.
// Store ratings are a manual snapshot: update `asOf` when you refresh the numbers.

export const company = {
  name: 'Singleton Games',
  legalName: 'Singleton Games, Co.',
  tagline: 'We build games and AI character experiences.',
  description:
    'Singleton Games is an independent studio based in Seoul. We make pixel-art mobile games and AI character stories for players in Japan and worldwide.',
  email: 'help@singletongames.co',
  youtube: 'https://www.youtube.com/@SingletonGames'
};

export const goddessMecha = {
  id: 'goddess-mecha',
  name: 'Goddess Mecha',
  nameJa: '女神メカ',
  platform: 'iOS · Android',
  tagline: 'Pixel-art tower defense meets AI character chat.',
  description:
    'In 2124, Mecha City is the last stronghold on Earth. Command the Goddesses, pilot heroines of the mech city, and hold the line against waves of 1,000+ mutated monsters. Every run plays out roguelike-style: your picks of guns, skills, drones and turrets shape the build. After the defense, the story continues through 1:1 AI chat with each Goddess.',
  youtubeId: 'c3odi9Jr_Ww',
  youtubeTitle: 'Goddess Mecha Pre-release Trailer',
  appStore: 'https://apps.apple.com/app/goddess-mecha/id6503224821',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.singletongames.xxd',
  ratings: {
    asOf: 'Oct 2026',
    googlePlay: { score: 4.0, count: 778, installs: '10K+' },
    appStore: { score: 4.2 }
  },
  features: [
    {
      title: 'Tower Defense × Roguelike',
      body: 'Each stage hands you a different set of skills. Combine guns, drones and turrets into a build that clears the wave.'
    },
    {
      title: '1:1 AI Character Chat',
      body: 'Unlock episodes after each defense and talk with the Goddesses at your own pace. Dialogue moves the story forward.'
    },
    {
      title: 'Bond System',
      body: 'Affinity grows through both combat and conversation, and unlocks rewards as it rises.'
    },
    {
      title: 'CG Collection',
      body: 'Secret illustrations and animations open up as your relationships progress.'
    }
  ],
  screenshots: [
    { src: '/img/gm/ss-battle.jpg', alt: 'Goddess Mecha battle: a wave of monsters pushes toward the mech line' },
    { src: '/img/gm/ss-chat.jpg', alt: 'Goddess Mecha AI chat with a Goddess character' },
    { src: '/img/gm/ss-character.jpg', alt: 'Goddess Mecha character and gear screen' }
  ],
  reviews: [
    {
      stars: 5,
      text: 'Very addictive and very simple gameplay. Just make sure you upgrade!',
      author: 'Finga Trigga',
      source: 'Google Play'
    },
    {
      stars: 5,
      text: 'Cute pixel tower defense game. Having fun with it so far. Keep up the good work.',
      author: 'Thesis-D',
      source: 'Google Play'
    }
  ]
};

export const ibashoTown = {
  id: 'ibasho-town',
  name: 'Ibasho Town',
  nameJa: 'イバショタウン',
  platform: 'Web · Japanese',
  sloganJa: '今日、誰かに会える場所。',
  slogan: 'A place where you can meet someone today.',
  tagline: 'An interactive story game on the web, where free AI conversation replaces the choice menu.',
  description:
    '"What if, that day, you had taken a different train?" Ibasho Town is a town made of the roads not taken. At the club, the garage, the hospital, the gym, someone is waiting with a story of their own. What you say decides which route opens.',
  url: 'https://chat.ibasho.town/ja',
  map: { src: '/img/ibasho/map-ja.webp', alt: 'Ibasho Town guide map (Japanese): a seaside town at dusk with a station, plaza, clock tower, school and lighthouse' },
  features: [
    {
      title: 'Multi-ending Story',
      titleJa: 'マルチエンディングストーリー',
      body: 'Your words and actions open new routes. The fun of choosing a story in a visual novel, and the fun of talking freely in character chat, in one.'
    },
    {
      title: 'Checkpoints',
      titleJa: 'チェックポイント',
      body: 'Each episode has checkpoints to reach: affection, trust, friendship, score. Hit one and the next part of the story unlocks.'
    },
    {
      title: 'Long-term Memory',
      titleJa: '長期記憶',
      body: 'Memory carries across episodes. A passing joke or a small promise from before can come back later.'
    },
    {
      title: 'CG Collection',
      titleJa: 'CGコレクション',
      body: 'Moments you do not want to forget can be unlocked and kept in your album.'
    }
  ],
  places: [
    { src: '/img/ibasho/station.jpg', alt: 'Ibasho Town station at dusk' },
    { src: '/img/ibasho/plaza.jpg', alt: 'Ibasho Town plaza with the clock tower' }
  ]
};
